import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TrSidebarComponent } from './tr-sidebar.component';
import { ClockModule } from '@tablesready/frontend-alerts-bar';
import { GuiderModule } from '@tablesready/frontend-guider';
import { JoyrideModule } from 'ngx-joyride';
import { Angulartics2Module } from 'angulartics2';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendSettingsNavModule } from '@tablesready/frontend-settings-nav';

@NgModule({
  declarations: [
    TrSidebarComponent
  ],
  imports: [
    CommonModule,
    ClockModule,
    RouterModule,
    GuiderModule,
    JoyrideModule.forRoot(),
    Angulartics2Module,
    FrontendIconsModule,
    FrontendSettingsNavModule,
  ],
  exports: [
    TrSidebarComponent
  ]
})
export class SidebarModule {}
